import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.employment
)

export const selectVacancies = createSelector(
    baseSelector,
    (state) => state.vacancies
)

export const selectVacanciesError = createSelector(
    baseSelector,
    (state) => state.vacanciesError
)

export const selectVacanciesLoading = createSelector(
    baseSelector,
    (state) => state.isApplicationsLoading
)

export const selectVacanciesFirstLoad = createSelector(
    baseSelector,
    (state) => state.isApplicationsFirstLoad
)

export const selectJobApplicationsLoading = createSelector(
    baseSelector,
    (state) => state.isApplicationsLoading
)
export const selectJobApplicationsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isApplicationsFirstLoad
)
export const selectJobApplicationsError = createSelector(
    baseSelector,
    (state) => state.applicationsError
)
export const selectJobApplications = createSelector(
    baseSelector,
    (state) => state.applications
)
export const selectCurrentStatus = createSelector(
    baseSelector,
    (state) => state.selectedApplicationStatus
)